import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Revenue from './pages/Revenue';
import Users from './pages/Users';
import Devices from './pages/Devices';
import Lockers from './pages/Lockers';
import Orders from './pages/Orders';
import ParcelHistory from './pages/ParcelHistory';
import LiveLockers from './pages/LiveLockers';
import Alerts from './pages/Alerts';
import { Logs } from './pages/AdminPages';
import { Menu } from 'lucide-react';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#07080c', color: '#8a8da4' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

function useIsMobile() {
  const q = '(max-width: 900px)';
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => (mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on));
  }, []);
  return m;
}

function Layout({ children }) {
  const mobile = useIsMobile();
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar mobile={mobile} open={!mobile || open} onClose={() => setOpen(false)} />
      <main style={{ marginLeft: mobile ? 0 : 250, flex: 1, minWidth: 0, padding: mobile ? 14 : 28, background: '#07080c', minHeight: '100vh' }}>
        {mobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <button aria-label="Menu" onClick={() => setOpen(true)}
              style={{ background: '#0f1117', border: '1px solid #252733', borderRadius: 8, padding: 10, color: '#e4e5ed', cursor: 'pointer', display: 'flex' }}>
              <Menu size={20} />
            </button>
            <span style={{ fontWeight: 700, color: '#e4e5ed' }}>Dami<span style={{ color: '#8BC63E' }}>tove</span> Admin</span>
          </div>
        )}
        <div style={{ overflowX: 'auto' }}>{children}</div>
      </main>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/revenue" element={<ProtectedRoute><Layout><Revenue /></Layout></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Layout><Pricing /></Layout></ProtectedRoute>} />
      <Route path="/devices" element={<ProtectedRoute><Layout><Devices /></Layout></ProtectedRoute>} />
      <Route path="/lockers" element={<ProtectedRoute><Layout><Lockers /></Layout></ProtectedRoute>} />
      <Route path="/orders" element={<ProtectedRoute><Layout><Orders /></Layout></ProtectedRoute>} />
      <Route path="/parcels" element={<ProtectedRoute><Layout><ParcelHistory /></Layout></ProtectedRoute>} />
      <Route path="/live-lockers" element={<ProtectedRoute><Layout><LiveLockers /></Layout></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><Layout><Alerts /></Layout></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute><Layout><Users /></Layout></ProtectedRoute>} />
      <Route path="/logs" element={<ProtectedRoute><Layout><Logs /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

